export enum ToastNotificationTypeEnum {
  info = 'info',
  success = 'success',
  error = 'error',
  warning = 'warning',
}
